import { RADAR_GRID_IDS } from "@/views/enterprise/live-map/layers/radar-grid/consts/radarGridLayerConstants";

export function useRadarGridEvents({ map, popupManager, pathManager }) {
  const setupRadarObjectClick = () => {
    if (!map) return;

    map.on("click", RADAR_GRID_IDS.RADAR_LAYER_ID, async e => {
      const properties = e.features[0].properties;
      const objId = properties.id;

      if (popupManager.hasPopup(objId)) {
        popupManager.removePopup(objId);
        pathManager.removeObjectFromSource(objId);
        return;
      }

      // 航跡取得（非同期）
      await pathManager.setPastPath(objId);

      const clickPoint = {
        x: `${e.point.x}px`,
        y: `${e.point.y}px`,
      };

      popupManager.appendPopup(properties, clickPoint);
    });

    map.on("mouseenter", RADAR_GRID_IDS.RADAR_LAYER_ID, () => {
      map.getCanvas().style.cursor = "pointer";
    });

    map.on("mouseleave", RADAR_GRID_IDS.RADAR_LAYER_ID, () => {
      map.getCanvas().style.cursor = "";
    });
  };

  return {
    setupRadarObjectClick,
  };
}
